(function(){
  'use strict';

  var phrases=[
    'bienvenido','bienvenida','10% de descuento','obtén un 10','obten un 10',
    'reclamar descuento','desbloquea tu descuento','welcome discount','welcome offer'
  ];

  var selectors=[
    '[id*="sendwill" i]','[class*="sendwill" i]',
    '[id*="discount-popup" i]','[class*="discount-popup" i]',
    '[id*="welcome-popup" i]','[class*="welcome-popup" i]',
    '[id*="newsletter-popup" i]','[class*="newsletter-popup" i]',
    '[data-testid*="discount" i]','[data-testid*="welcome" i]',
    'iframe[src*="sendwill" i]','iframe[src*="shopify-forms" i]',
    'iframe[src*="forms.shopify" i]','iframe[src*="discount" i]',
    'iframe[title*="discount" i]','iframe[title*="welcome" i]',
    'iframe[name*="discount" i]','iframe[name*="welcome" i]'
  ];

  function normalize(value){
    return String(value||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  }

  function hasDiscountPhrase(value){
    var text=normalize(value);
    return phrases.some(function(p){return text.indexOf(normalize(p))>-1;});
  }

  function attributesText(el){
    if(!el||!el.getAttribute)return '';
    return [
      el.id,el.className,el.getAttribute('title'),el.getAttribute('aria-label'),
      el.getAttribute('name'),el.getAttribute('src'),el.getAttribute('data-testid')
    ].join(' ');
  }

  function looksLikePopup(el){
    if(!el||el.nodeType!==1)return false;
    try{if(el.matches(selectors.join(',')))return true;}catch(e){}

    var attrText=attributesText(el);
    if(hasDiscountPhrase(attrText))return true;

    var text='';
    try{text=el.innerText||el.textContent||'';}catch(e){}
    if(!hasDiscountPhrase(text))return false;

    var style;
    try{style=window.getComputedStyle(el);}catch(e){return false;}
    var role=el.getAttribute('role');
    return style.position==='fixed'||style.position==='sticky'||role==='dialog'||el.getAttribute('aria-modal')==='true';
  }

  function unlockPage(){
    [document.documentElement,document.body].forEach(function(el){
      if(!el)return;
      el.style.removeProperty('overflow');
      el.style.removeProperty('position');
      el.classList.remove('modal-open','popup-open','no-scroll');
    });
  }

  function removeElement(el){
    if(!el)return;
    try{
      el.style.setProperty('display','none','important');
      el.style.setProperty('visibility','hidden','important');
      el.style.setProperty('opacity','0','important');
      el.setAttribute('aria-hidden','true');
      if(el.parentNode)el.parentNode.removeChild(el);
    }catch(e){}
    unlockPage();
  }

  function scanRoot(root){
    if(!root||!root.querySelectorAll)return;

    selectors.forEach(function(sel){
      try{root.querySelectorAll(sel).forEach(removeElement);}catch(e){}
    });

    try{
      root.querySelectorAll('*').forEach(function(el){
        if(looksLikePopup(el))removeElement(el);
        if(el.shadowRoot)scanRoot(el.shadowRoot);
      });
    }catch(e){}
  }

  function start(){
    scanRoot(document);

    var observer=new MutationObserver(function(records){
      records.forEach(function(record){
        record.addedNodes.forEach(function(node){
          if(node.nodeType!==1)return;
          if(looksLikePopup(node))removeElement(node);
          else scanRoot(node);
        });
      });
    });

    observer.observe(document.documentElement,{childList:true,subtree:true});

    [250,750,1500,3000,6000,10000].forEach(function(delay){
      setTimeout(function(){scanRoot(document);},delay);
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);
  else start();
})();
